import { css } from '@emotion/css';

export const setColor = (colorHexValue?: string) => css`
  color: ${colorHexValue || '#000000'};
`;

export const popoverContent = css`
  max-height: 52rem;
`;

export const listItem = css`
  width: 19.6rem;
`;

export const iconButtonMenu = css`
  height: 2.8rem;
  margin: 0.6rem;
  .chevron {
    width: 1.6rem;
    height: 1.6rem;
  }
  :hover .chevron {
    color: var(--icon-active);
  }
`;
